module.exports = __webpack_public_path__ + "static/media/Auth0-webauthn-1.0f631377.png";